import React, { useState } from 'react';
import { useEffectAsync } from '../../helpers';
import { useLazyUserProfileImageQuery } from '../../graphql/graphql';

interface Props {
	userId: string;
	customClass?: string;
	type?: 'img' | 'background';
}

const UserAvatar: React.FC<Props> = ({
	userId,
	customClass = null,
	type = 'img',
}) => {
	const [getUserAvatar] = useLazyUserProfileImageQuery();
	const [avatarUrl, setAvatarUrl] = useState<string>(
		'/dist/placeholder/user-placeholder.png',
	);

	useEffectAsync(async () => {
		if (userId) {
			const { user } = await getUserAvatar({
				userId,
			}).unwrap();
			setAvatarUrl(
				user?.profileImageUrl ?? '/dist/placeholder/user-placeholder.png',
			);
		}
	}, []);

	if (type === 'img') {
		return (
			<img
				src={avatarUrl}
				alt={'avatar'}
				className={customClass ?? undefined}
			/>
		);
	}

	return (
		<div
			className={customClass ?? undefined}
			style={{ backgroundImage: `url("` + avatarUrl + `")` }}
		/>
	);
};

export default UserAvatar;
